import { render, staticRenderFns } from "./setup_profile.vue?vue&type=template&id=172623de&"
import script from "./setup_profile.vue?vue&type=script&lang=js&"
export * from "./setup_profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports